import { Activity } from '../../types/GrooverTypes'
import { GtmActivityMetadata } from './gtmTypes'

export const oreToMajorUnits = (ore: number | undefined): number => (ore ?? 0) / 100

export const toGtmActivityMetadata = (activity: Activity): GtmActivityMetadata => ({
  id: activity.id,
  name: activity.name,
  type: activity.type,
  period: activity.period,
  startDate: activity.startDate,
  style: activity.style,
  place: activity.place,
  city: activity.city,
  price: oreToMajorUnits(activity.price)
})
